module.exports = "/_next/static/images/cloudsharks-testimonial-147482cc2e40ce75c0355b767e3a6d4a.jpg";